import { BrowserRouter, Routes, Route } from "react-router-dom";

import HomePage from "./components/HomePage";
import CourseDetails from "./components/CourseDetails";
import ClickEffect from "./components/ClickEffect";

function App() {
  return (
    <BrowserRouter>
    <ClickEffect/>
      <Routes>

        <Route path="/" element={<HomePage />} />

        <Route
          path="/courses/:slug"
          element={<CourseDetails />}
        />
        

      </Routes>
    </BrowserRouter>
  );
}

export default App;